module.exports = __webpack_public_path__ + "static/fahrenheit-451-3cc025d07e8b98f9e9d25919c82fbe54.jpg";